export default {
  methods: {
    firstMainProductImage (product) {
      return product.images[parseInt(Object.keys(product.images)[0])].find(image => image.is_main === '1')
    }
  }
}
